// extracted by css-extract-rspack-plugin
export default {"borderGrid":"CodeViewSidebar-module__borderGrid__Lpx5q"};